import React from 'react';
import { Calendar } from 'lucide-react';

const ChartFooter = ({ dateRange }) => {
    if (!dateRange || !dateRange.start_date || !dateRange.end_date) {
        return null;
    }

    const formatDate = (dateString) => {
        if (!dateString) return '';
        const options = { year: 'numeric', month: 'short', day: 'numeric' };
        return new Date(dateString).toLocaleDateString(undefined, options);
    };

    return (
        <div className="flex items-center justify-end mt-4 pt-3 border-t border-gray-100">
            <div className="flex items-center text-xs text-gray-400 bg-gray-50 px-2 py-1 rounded-md">
                <Calendar className="h-3 w-3 mr-1.5" />
                <span>
                    {formatDate(dateRange.start_date)} - {formatDate(dateRange.end_date)}
                </span>
            </div>
        </div>
    );
};

export default ChartFooter;
